var _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 500 500)",
    id: 581259
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.4647 0 0 25.4647 179.8571 34.5297)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(41,142,209)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-22.771, -17.064)",
    d: "M 28.755 6.968 l -0.47 0.149 L 25.782 7.34 l -0.707 1.129 l -0.513 -0.163 L 22.57 6.51 l -0.289 -0.934 L 21.894 4.58 l -1.252 -1.123 l -1.477 -0.289 l -0.034 0.676 l 1.447 1.412 l 0.708 0.834 L 20.49 6.506 l -0.648 -0.191 L 18.871 5.91 l 0.033 -0.783 l -1.274 -0.524 l -0.423 1.841 l -1.284 0.291 l 0.127 1.027 l 1.673 0.322 l 0.289 -1.641 l 1.381 0.204 l 0.642 0.376 h 1.03 l 0.705 1.412 l 1.869 1.896 l -0.137 0.737 l -1.507 -0.192 l -2.604 1.315 l -1.875 2.249 l -0.244 0.996 h -0.673 l -1.254 -0.578 l -1.218 0.578 l 0.303 1.285 l 0.53 -0.611 l 0.932 -0.029 l -0.065 1.154 l 0.772 0.226 l 0.771 0.866 l 1.259 -0.354 l 1.438 0.227 l 1.67 0.449 l 0.834 0.098 l 1.414 1.605 l 2.729 1.605 l -1.765 3.372 l -1.863 0.866 l -0.707 1.927 l -2.696 1.8 l -0.287 1.038 c 6.892 -1.66 12.019 -7.851 12.019 -15.253 C 31.413 12.474 30.433 9.465 28.755 6.968 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.4647 0 0 25.4647 -167.7492 95.8998)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(41,142,209)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-9.1205, -19.474)",
    d: "M 17.515 23.917 l -1.144 -2.121 l 1.05 -2.188 l -1.05 -0.314 l -1.179 -1.184 l -2.612 -0.586 l -0.867 -1.814 v 1.077 h -0.382 l -2.251 -3.052 v -2.507 L 7.43 8.545 L 4.81 9.012 H 3.045 L 2.157 8.43 L 3.29 7.532 L 2.16 7.793 c -1.362 2.326 -2.156 5.025 -2.156 7.916 c 0 8.673 7.031 15.707 15.705 15.707 c 0.668 0 1.323 -0.059 1.971 -0.137 l -0.164 -1.903 c 0 0 0.721 -2.826 0.721 -2.922 C 18.236 26.357 17.515 23.917 17.515 23.917 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25.4647 0 0 25.4647 -69.0861 -327.2856)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(41,142,209)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12.995, -2.8555)",
    d: "M 5.84 5.065 l 2.79 -0.389 l 1.286 -0.705 l 1.447 0.417 l 2.312 -0.128 l 0.792 -1.245 l 1.155 0.19 l 2.805 -0.263 L 19.2 2.09 l 1.09 -0.728 l 1.542 0.232 l 0.562 -0.085 C 20.363 0.553 18.103 0 15.708 0 C 10.833 0 6.474 2.222 3.596 5.711 h 0.008 L 5.84 5.065 z M 16.372 1.562 l 1.604 -0.883 l 1.03 0.595 l -1.491 1.135 l -1.424 0.143 l -0.641 -0.416 L 16.372 1.562 z M 11.621 1.691 l 0.708 0.295 l 0.927 -0.295 l 0.505 0.875 l -2.14 0.562 l -1.029 -0.602 C 10.591 2.526 11.598 1.878 11.621 1.691 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagWorld);
export default __webpack_public_path__ + "static/media/flag-world.c1bd5e6717e581971f853cd537deab90.svg";
export { ForwardRef as ReactComponent };